/** Default m8t telemetry ingest base URL (public, non-secret). Overridable via
 *  M8T_INGEST_BASE_URL — the smoke points this at a throwaway/branch ingest. */
export const INGEST_BASE_URL: string =
  (process.env.M8T_INGEST_BASE_URL ?? "").trim() ||
  "https://m8t-admin.wonderfuldesert-721e332f.eastus2.azurecontainerapps.io";

export function ingestUrl(path: string): string {
  const base = INGEST_BASE_URL.replace(/\/+$/, "");
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}
